import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { StoreProvider } from "@/context/StoreContext";
import { Toaster } from "@/components/ui/sonner";
import { AnnouncementBar } from "@/components/AnnouncementBar";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { AIStylist } from "@/components/AIStylist";
import { SizeFinder } from "@/components/SizeFinder";
import { SpinToWin } from "@/components/SpinToWin";
import { SocialProof } from "@/components/SocialProof";
import { ReviewPopup } from "@/components/ReviewPopup";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Product from "@/pages/Product";
import Wishlist from "@/pages/Wishlist";
import Rewards from "@/pages/Rewards";

function App() {
  return (
    <StoreProvider>
      <BrowserRouter>
        <AnnouncementBar />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/collections/:handle" element={<Shop />} />
            <Route path="/product/:handle" element={<Product />} />
            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="/rewards" element={<Rewards />} />
          </Routes>
        </main>
        <Footer />
        <CartDrawer />
        <AIStylist />
        <SizeFinder />
        <SpinToWin />
        <SocialProof />
        <ReviewPopup />
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </StoreProvider>
  );
}

export default App;
